import waitDomReady from "../utilities/waitDomReady";

export default async function loadPlugins() {
    await waitDomReady();
    let modules = [];
    const elements = document.querySelectorAll('[data-toggle="collapse"]');
    if (elements.length > 0) {
        import("./collapse").then(module => {
            const loadPlugin = module.default;
            loadPlugin(elements);
            modules.push(module);
        });
    }

    return () => {
        modules.forEach(module => module.unloadPlugin());
    }
}